import React from 'react';
import { useI18n } from 'utils/I18n/context';

export default function ServerErrorPage() {
    const { t } = useI18n();
    const staticNames = t?.errorPage?.server || {};

    return (
        <div className="error-page error-500 text-center" role="alert" aria-live="assertive">
            <h1>500</h1>
            <h3 className="font-bold">{staticNames.title || 'Server error'}</h3>
            <div className="error-desc">{staticNames.text || 'Something went wrong. Please try again later.'}</div>
            <div style={{marginTop: 24}}>
                <button className="btn btn-primary" onClick={() => window.location.reload()}>Reload</button>
                <button className="btn btn-default" style={{marginLeft: 8}} onClick={() => window.history.back()}>Go back</button>
            </div>
        </div>
    );
}
